import { generateId } from '@freelancer/datastore/testing';
import { Enterprise } from '../enterprise/enterprise.model';
import { AdminEnterpriseModel } from './admin-enterprises.model';

export interface GenerateAdminEnterpriseOptions {
  readonly id?: number;
  readonly internalName: string;
  readonly name: string;
  readonly seoUrl: string;
  readonly isTestEnterprise?: boolean;
  readonly dateCreated?: number;
  readonly membersCount: number;
}

export function generateAdminEnterpriseObject({
  id,
  internalName,
  name,
  seoUrl,
  isTestEnterprise = false,
  dateCreated = Date.now(),
  membersCount,
}: GenerateAdminEnterpriseOptions): AdminEnterpriseModel {
  return {
    id: id || generateId(),
    internalName,
    name,
    seoUrl,
    isTestEnterprise,
    dateCreated,
    membersCount,
  };
}

export function generateAdminEnterpriseObjects(
  enterpriseOptionsList: readonly GenerateAdminEnterpriseOptions[],
): readonly AdminEnterpriseModel[] {
  return enterpriseOptionsList.map(enterpriseOptions =>
    generateAdminEnterpriseObject(enterpriseOptions),
  );
}

export function facebookAdminEnterprise(): GenerateAdminEnterpriseOptions {
  return {
    id: Enterprise.FACEBOOK,
    internalName: 'facebook',
    seoUrl: 'facebook',
    name: 'Facebook, Inc',
    membersCount: 10,
    dateCreated: new Date(2019, 3, 15).getTime(),
  };
}
